<template>
    <div>
        <table class="table w-full">
            <thead>
                <tr>
                    <th class="text-center">Sales Rep</th>
                    <th class="text-right">Total Item Cost</th>
                    <th class="text-right">Total Item Sales</th>
                    <th class="text-right">Profit ($)</th>
                    <th class="text-right">Margin (%)</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="rep in data" :key="rep.id">
                    <template v-if="rep.sales !== 0">
                        <td class="text-center">{{ rep.name }}</td>
                        <td class="text-right">{{ toCurrency(rep.cost) }}</td>
                        <td class="text-right">{{ toCurrency(rep.sales) }}</td>
                        <td class="text-right">{{ rep.margin !== 0 ? toCurrency(rep.profit) : '--' }}</td>
                        <td class="text-right">{{ rep.margin !== 0 ? rep.margin.toFixed(1) + '%' : '--' }}</td>
                    </template>
                    <template v-else>
                        <td v-if="rep.sales === 0" colspan="5" class="py-4 text-center">No sales to report</td>
                    </template>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
export default {
    props: ['data']

}
</script>

<style scoped>

</style>
